module.exports = __webpack_public_path__ + "static/media/screen4.5bc588d7.png";